//#region types
import { AuthEnums } from "models/enums";
//#endregion
import useAPIClientHelper from "./useAPIClientHelper";

interface StripeConnectInitiateResponse {
  oauthUrl?: string;
  oAuthUrl?: string;
}

export interface StripeConnectStatusResponse {
  isEnrolled?: boolean;
  isConnected?: boolean;
  accountId?: string;
  accountStatus?: number | string;
  syncMode?: "notConnected" | "manualReview" | "automatic";
}

const stripeConnectApiUrl = "api/services/stripe/connect";

function useStripeConnectService() {
  const { apiClientInstance } = useAPIClientHelper();

  // Stripe Connect endpoints are not generated in wint-api-client yet, so keep the raw routes centralized here.
  const getStatus = () => {
    return apiClientInstance(AuthEnums.AuthType.Company, { showErrors: false, timeout: 8000 })
      .get(`${stripeConnectApiUrl}/status`)
      .then((res) => res.data as StripeConnectStatusResponse);
  };

  const initiateConnect = (returnPath?: string) => {
    return apiClientInstance(AuthEnums.AuthType.Company, {
      showErrors: true,
    })
      .post(`${stripeConnectApiUrl}/initiate`, { returnPath })
      .then((res) => res.data as StripeConnectInitiateResponse);
  };

  const disconnect = (accountId: string) => {
    return apiClientInstance(AuthEnums.AuthType.Company, {
      showErrors: true,
    }).delete(`${stripeConnectApiUrl}/${accountId}`);
  };

  return {
    disconnect,
    getStatus,
    initiateConnect,
  };
}

export default useStripeConnectService;
